module.exports = __webpack_public_path__ + "img/small.34a6916e.jpg";